export const COMPANY_STATUSES = {
    INITIAL: 'initial',
    VERIFIED: 'verified',
    CANCELLED: 'cancelled'
}